<template>
  <div>
    <div class="d-flex justify-content-center align-items-center mb-3" style="min-height: 70px;background:#3b71de10;width:100%;">
      <div class="row text-capitalize">
        <span style="font-weight: 600;font-size: 18px;">
          {{ $t("carts.gift") }}
        </span>
      </div>
    </div>

    <div class="pb-5 mb-2 mb-md-4 rtl" style="text-align: left;">
      <div class="row mt-3">
        <div v-for="item in promGifts" class="col-lg-3 col-md-4 col-sm-4 col-6 pb-3">
          <div class="h-100">
            <div 
              class="inline_product clickable d-flex justify-content-center"
              style="cursor: pointer;background:#3b71de10; border-radius: 5px 5px 0px 0px;"
            >
              <div class="d-flex justify-content-end for-dicount-div-null">
                <span class="for-discoutn-value-null"></span>
              </div>
              <div class="d-flex d-block" style="cursor: pointer;" @click="handleQuickView(item,false)">
                <el-image
                  :src="imgProxy(item.image_url, rs='fill:250:250:1')"
                  :alt="dt(item.name_translations)"
                  style="width: 100%; border-radius:5px 5px 0px 0px;"
                >
                  <template #error>
                    <img
                      src="/static/assets/front-end/img/image-place-holder.png"
                      :alt="dt(item.name_translations)"
                      style="width: 100%;
                    /">
                  </template>
                </el-image>
              </div>
            </div>

            <div class="single-product-details" style="position:relative; padding-top:10px; border-radius:0px 0px 5px 5px; ">
              <div class="text-left pl-3" @click="handleQuickView(item,false)">
                {{ dt(item.name_translations) }}
              </div>
            </div>

            <a v-if="promotion.condition_min_type == 'amount'" class="btn btn-primary btn-block mt-2 disabled" role="button" aria-disabled="true" href="#">
              {{ t("promotions.fill") }}
              {{ item.condition.min_amount }}, {{ t("promotions.gift") }}{{item.condition.discountable_quantity}} {{ t("promotions.fillUnit") }}
            </a>
            <a v-if="promotion.condition_min_type == 'qty'" class="btn btn-primary btn-block mt-2 disabled" role="button" aria-disabled="true" href="#">
              {{ t("promotions.fill") }}
              {{ item.condition.min_qty }} {{ t("promotions.fillUnit") }}, {{ t("promotions.gift") }}{{item.condition.discountable_quantity}} {{ t("promotions.fillUnit") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, imgProxy } from "../../utils"

const props = defineProps({
  promotion: Object,
})
const { t, n, locale } = useI18n()

const promDiscountableStoreProductMap = computed(() => _.keyBy(props.promotion.discountable_store_products, "id"));
const promGifts = computed(() => {
    let tmpGifts = []
    if (props.promotion.discount_type == 'gift') {
        props.promotion.conditions.forEach((condition) => {
            condition.discountable_store_product_ids.forEach((store_product_id) => {
                const gift = _.cloneDeep(promDiscountableStoreProductMap.value[store_product_id.toString()])
                if (gift) {
                    gift.condition = condition
                    tmpGifts.push(gift)
                }
            })
        })
    }
    return tmpGifts
})
</script>
